export const {
    FAQModal,
    TermsModal,
    EligibilityModal,
  } = require('./modals'),
  SideNav = require('./SideNav').default,
  TabFlow = require('./TabFlow').default,
  Navigation = require('./Navigation').default;
